import { render, staticRenderFns } from "./ExpedienteEdit.vue?vue&type=template&id=37a4e984"
import script from "./ExpedienteEdit.vue?vue&type=script&lang=js"
export * from "./ExpedienteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports